'use strict';

import * as Onyx from '../lib/onyx.min.js';

const SCALE = 25;
const FLOOR_SIZE = 3000.0;
const RAY_LAYERS = 2;
const RAY_LAYERS_Z_MIN = -5;
const RAY_LAYERS_Z_MAX = -1500;
const RAY_LAYERS_Y_0 = 0;
const RAY_LAYERS_Y_MAX = 512;

export default class Background extends Onyx.Entity {
    constructor(position = [0, 0, 0], scale = 1, rotation = 0, { caustic = null, godrays = null } = {}){
        super();

        this.floors = [];
        this.rays = [];
        
        this.transform.translateTo(position[0], position[1], position[2]);

        Onyx.ImportModelFromOBJ.load({src: "res/models/seafloor.obj"}).then((model) => {
            // Floor
            let floor = model;

            floor.meshes[0].material.ambientTexture = caustic;
            floor.meshes[0].material.buildProgram();

            floor.transform.scale(SCALE, SCALE, SCALE);
            // floor.transform.translateTo(FLOOR_SIZE * x, 0, -FLOOR_SIZE * y);

            this.floors.push(floor);
            this.addComponent(model);

            // this.addRays(godrays);
        });
    }

    addRays(godrays){
        for(var j = 0; j < RAY_LAYERS; j++){
            for(var i = 0; i < COLUMN_COUNT; i++){
                // Rays
                let rays = new Onyx.Model({
                    meshes: [new Onyx.Mesh({
                        material: new Onyx.MaterialPhong("", {
                            lighting: 0,
                            ambientTexture: godrays,
                            ambientTextureCoordinateSpace: "UVtoXY",
                            ambientTextureFlipY: true,
                            receivesFog: false
                        })
                    }).addPlane(FLOOR_SIZE, FLOOR_SIZE)]
                });
                
                rays.transform.translateTo(
                    FLOOR_SIZE * i - (FLOOR_SIZE / 2), 
                    RAY_LAYERS_Y_MAX - (j * ((RAY_LAYERS_Y_MAX - RAY_LAYERS_Y_0) / RAY_LAYERS)), 
                    RAY_LAYERS_Z_MAX - (j * ((RAY_LAYERS_Z_MAX - RAY_LAYERS_Z_MIN) / RAY_LAYERS))
                );

                this.rays.push(rays);
                this.addComponent(rays);
            }
        }
    }
}